/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  config: {
    apiKey: 'AIzaSyB7pnk2IxOiRgyX-Yttg-lISNsSFLAWUa8',
    authDomain: 'pjp-admin.firebaseapp.com',
    databaseURL: 'https://pjp-admin.firebaseio.com',
    projectId: 'pjp-admin',
    storageBucket: 'pjp-admin.appspot.com',
    messagingSenderId: '1017240848808',
  },
   algolia: {
    appId: 'ZZNYAL3T8A',
    apiKey: 'f84db77ec90b5d010369928c91ba52b1',
  },
  // Marker.io feedback widget, loaded for admins only (see header.component.ts)
  marker: {
    project: '6aa9729970961cc812d90994',
  },
};
